<template>
    <div class="sidebar-overlay" :class="{ 'show': sideBarState }" @click="changeSideBarState"></div>
    <div class="weeduc-sidebar sidebar primary" :class="{ 'show': sideBarState }">
        <fa v-if="sideBarState && isMobile" icon="fa-times" class="icon-close" @click="changeSideBarState"/>
        <div class="sidebar-header">
            <div class="header-logo">
                <div class="logo"  v-if="isMobile && !sideBarState"  @click="$router.push('/dashboard/painel')">
                    <img class="logo_black" src="./../../assets/weeduc-icone.svg" style="width: 100%;">
                    <img class="logo_white" src="./../../assets/weeduc-icone.svg" style="width: 100%;">
                </div>
                <div class="logo" v-else @click="$router.push('/dashboard/painel')">
                    <img class="logo_black" src="./../../assets/logo_white.png" style="width: 100%;">
                    <img class="logo_white" src="./../../assets/logo_white.png" style="width: 100%;">
                </div>
            </div>
        </div>
        <div class="sidebar-content">
            <div class="content-link">
                <template v-for="(itens, index) in menuItems" :key="itens.link || itens.section">
                    <div v-if="itens.section" class="corporate-sidebar-section">
                        {{ itens.section }}
                    </div>
                    <div v-else class="link">
                        <router-link
                            class="link-content primary"
                            :to="itens.link"
                            :class="{ active: isActiveLink(itens.link) }"
                            @click="setActiveIndex(index)"
                        >
                            <span class="link-icon">
                                <fa :icon="itens.icon" style="font-size: 1rem"/>
                            </span>
                            <span class="link-text">
                                <span class="text">
                                   {{ itens.name }}
                                </span>
                            </span>
                        </router-link>
                    </div>
                </template>
            </div>
        </div>
        <div class="version">
            <span class="version-text desktop">
                {{ $t('common.version') }}: {{ versionPortalWeeduc || $t('common.unknown') }}
            </span>
            <span class="version-text mobile">
                {{ $t('common.version') }}: {{ versionPortalWeeduc || $t('common.versionUnknown') }}
            </span>
        </div>
    </div>
</template>

<script>
import store from '@/store';
import { mapState, mapActions } from 'vuex';
import {
    isCorporateEnvironment,
    isCorporateModuleEnabled,
} from '@/utils/corporate/environment';
import { canConfigureCorporate, canManageCorporateCourses } from '@/utils/corporate/permissions';
import {
    ADMIN_DASHBOARD_MODE,
    getAdminDashboardMode,
} from '@/utils/corporate/adminDashboardMode';
import { corporateI18n } from '@/i18n/mixins';

/** Itens compartilhados no menu corporativo + gate de módulo (null = sempre visível) */
/** Ordem do menu corporativo (module: null = sempre visível) */
const CORPORATE_MENU_ORDER = [
    { kind: 'core', key: 'overview' },
    { kind: 'core', key: 'structure' },
    { kind: 'core', key: 'collaborators' },
    { kind: 'shared', link: '/dashboard/cursos', module: null },
    { kind: 'core', key: 'liberacao', gate: 'courses' },
    { kind: 'shared', link: '/dashboard/avisos', module: null },
    { kind: 'shared', link: '/dashboard/duvidas', module: 'inquiry' },
    { kind: 'shared', link: '/dashboard/forum', module: 'forum' },
    { kind: 'shared', link: '/dashboard/certificados', module: 'certificate' },
    { kind: 'shared', link: '/dashboard/site', module: 'site' },
    { kind: 'shared', link: '/dashboard/integracoes', module: null },
    { kind: 'core', key: 'settings', gate: 'configure' },
    { kind: 'core', key: 'preferences', gate: 'configure' },
];

export default {
    mixins: [corporateI18n],
    data() {
        return {
            menu: [],
            activeIndex: null,
            secondoactiveindex: null,
            typeUser: '',
            windowWidth: window.innerWidth,
            iconsReports: ['fa-question-circle', 'fa-bookmark', 'fa-bell', 'fa-user', 'fa-money-bill', 'fa-chart-line'],
            linksReports: ['duvidas', 'foruns', 'avisos', 'usuarios', 'vendas', 'cursos'],
            versionPortalWeeduc: '',
        }
    },
    computed: {
        ...mapState(['sideBarState', 'adminDashboardMode', 'corporateCompanySettings', 'websites', 'company']),
        isMobile() {
            return this.windowWidth <= 768;
        },
        corporateEnabled() {
            // Reage a typeBusiness em company / websites.company
            void this.company;
            void this.websites;
            return isCorporateEnvironment();
        },
        dashboardMode() {
            void this.company;
            void this.websites;
            void this.adminDashboardMode;
            return getAdminDashboardMode();
        },
        corporateMenuItems() {
            if (!this.corporateEnabled) return [];

            void this.corporateCompanySettings;
            void this.websites;
            void this.$i18n.locale;

            const menu = this.t.menu;
            const byLink = new Map(this.baseSidebar.map((item) => [item.link, item]));
            const coreByKey = {
                overview: {
                    name: menu.overview,
                    link: '/dashboard/corporativo/visao-geral',
                    icon: 'fa-chart-pie',
                    type: 'corporate',
                },
                structure: {
                    name: menu.structure,
                    link: '/dashboard/corporativo/estrutura',
                    icon: 'fa-sitemap',
                    type: 'corporate',
                },
                collaborators: {
                    name: menu.collaborators,
                    link: '/dashboard/corporativo/colaboradores',
                    icon: 'fa-people-group',
                    type: 'corporate',
                },
                liberacao: {
                    name: menu.liberacao,
                    link: '/dashboard/corporativo/liberacoes',
                    icon: 'fa-link',
                    type: 'corporate',
                },
                settings: {
                    name: menu.settings,
                    link: '/dashboard/corporativo/empresa',
                    icon: 'fa-building',
                    type: 'corporate',
                },
                preferences: {
                    name: menu.preferences,
                    link: '/dashboard/corporativo/configuracoes',
                    icon: 'fa-sliders',
                    type: 'corporate',
                },
            };

            return CORPORATE_MENU_ORDER
                .filter((entry) => {
                    if (entry.gate === 'configure' && !canConfigureCorporate()) return false;
                    if (entry.gate === 'courses' && !canManageCorporateCourses()) return false;
                    if (entry.module && !isCorporateModuleEnabled(entry.module)) return false;
                    return true;
                })
                .map((entry) => {
                    if (entry.kind === 'core') {
                        return coreByKey[entry.key] || null;
                    }
                    const item = byLink.get(entry.link);
                    return item ? { ...item, type: 'corporate-shared' } : null;
                })
                .filter(Boolean);
        },
        baseSidebar() {
            void this.$i18n.locale;
            return [
                {
                    name: this.$t('sidebar.panel'),
                    link: '/dashboard/painel',
                    icon: 'fa-square-poll-vertical',
                    type: '0',
                },
                {
                    name: this.$t('sidebar.courses'),
                    link: '/dashboard/cursos',
                    icon: 'fa-book',
                    type: '0',
                },
                {
                    name: this.$t('sidebar.release'),
                    link: '/dashboard/liberacoes',
                    icon: 'fa-link',
                    type: '0',
                },
                {
                    name: this.$t('sidebar.doubts'),
                    link: '/dashboard/duvidas',
                    icon: 'fa-circle-question',
                    type: '0',
                },
                {
                    name: this.$t('sidebar.forum'),
                    link: '/dashboard/forum',
                    icon: 'fa-users',
                    type: '0',
                },
                {
                    name: this.$t('sidebar.warnings'),
                    link: '/dashboard/avisos',
                    icon: 'fa-bell',
                    type: '0',
                },
                {
                    name: this.$t('sidebar.certificates'),
                    link: '/dashboard/certificados',
                    icon: 'fa-certificate',
                    type: '1',
                },
                {
                    name: this.$t('sidebar.users'),
                    link: '/dashboard/usuarios',
                    icon: 'fa-user-group',
                    type: '1',
                },
                {
                    name: this.$t('sidebar.reports'),
                    link: '/dashboard/relatorios',
                    icon: 'fa-file-lines',
                    type: '1',
                },
                {
                    name: this.$t('sidebar.coupons'),
                    link: '/dashboard/cupons',
                    icon: 'fa-ticket',
                    type: '1',
                },
                {
                    name: this.$t('sidebar.site'),
                    link: '/dashboard/site',
                    icon: 'fa-earth-americas',
                    type: '1',
                },
                {
                    name: this.$t('sidebar.integrations'),
                    link: '/dashboard/integracoes',
                    icon: 'fa-plug',
                    type: '1',
                },
            ];
        },
        menuItems() {
            if (this.corporateEnabled && this.dashboardMode === ADMIN_DASHBOARD_MODE.CORPORATIVO) {
                return this.corporateMenuItems;
            }
            return [...this.baseSidebar];
        },
    },
    methods: {
        ...mapActions(['storeTypeId', 'storeSideBarState']),

        changeType() {
            this.storeTypeId({ typeId: this.typeUser })
        },
        isActiveLink(link) {
            if (!link) return false;
            const path = this.$route.path;
            if (link === '/dashboard/corporativo/colaboradores') {
                return path.startsWith(link);
            }
            return path === link || path.startsWith(`${link}/`);
        },
        setActiveIndex(index) {
            if (this.activeIndex === index) {
                // keep
            } else {
                if (this.setActiveIndex != 8) {
                    this.secondoactiveindex = null;
                }
                this.activeIndex = index;
            }
            localStorage.setItem('activeIndex', this.activeIndex);
        },
        setSecondIndex(index) {
            if (this.secondoactiveindex === index) {

            } else {
                this.secondoactiveindex = index;
            }
            localStorage.setItem('activeSecondIndex', this.secondoactiveindex);
            localStorage.setItem('activeIndex', this.activeIndex);
        },
        changeSideBarState() {
            this.storeSideBarState({ sideBarState: !this.sideBarState })
        },
        handleResize() {
            this.windowWidth = window.innerWidth;
            if (window.innerWidth > 768 && this.sideBarState) {
                return;
            }
        },
    },
    created() {
        this.typeUser = store.state.typeId;
        const savedActiveIndex = localStorage.getItem('activeIndex');
        const savedSecondoActiveIndex = localStorage.getItem('activeSecondIndex');
        
        if (savedActiveIndex !== null) {
            this.activeIndex = parseInt(savedActiveIndex, 10);
        }
        if (savedSecondoActiveIndex !== null) {
            this.secondoactiveindex = parseInt(savedSecondoActiveIndex, 10);
        }

        this.versionPortalWeeduc = process.env.VUE_APP_VERSION_PORTAL_WEEDUC;
    },
    
    mounted() {
        window.addEventListener('resize', this.handleResize);
    },
    beforeUnmount() {
        window.removeEventListener('resize', this.handleResize);
    }
}
</script>

<style scoped>
@import './sidebar.css';
.corporate-sidebar-section {
    margin: 0.85rem 0.35rem 0.35rem;
    padding: 0.35rem 0.4rem 0.15rem;
    font-size: 0.65rem;
    font-weight: 700;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: rgba(255, 255, 255, 0.45);
}
@media screen and (max-width: 768px) {
    .version-text.desktop {
        display: none;
    }
    .version-text.mobile {
        display: block;
    }
}
@media screen and (min-width: 768px) {
    .version-text.desktop {
        display: block;
    }
    .version-text.mobile {
        display: none;
    }
}

</style>
